import { Link } from "react-router-dom";
import { BookOpen, Scale, ArrowRight } from "lucide-react";

export const CodiceCivileMiniCard = () => (
    <section
        aria-label="Accesso rapido al Codice Civile"
        className="bg-white pb-12 sm:pb-16"
        data-testid="home-codice-civile-cta"
    >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <Link
                to="/codice-civile"
                data-testid="home-codice-civile-link"
                className="group flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-6 rounded-2xl border-2 border-teal-300 bg-gradient-to-br from-teal-50 via-white to-white p-5 sm:p-6 lg:p-8 shadow-[0_4px_14px_-8px_rgba(13,148,136,0.35)] hover:border-teal-500 hover:shadow-[0_14px_30px_-15px_rgba(13,148,136,0.55)] hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-teal-300/60 transition duration-200"
            >
                <div className="size-14 shrink-0 rounded-2xl bg-teal-600 text-white flex items-center justify-center shadow-[0_10px_20px_-10px_rgba(13,148,136,0.7)]">
                    <BookOpen className="size-7" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-[11px] uppercase tracking-widest text-teal-700 font-bold inline-flex items-center gap-1.5">
                        <Scale className="size-3.5" /> Riferimenti normativi
                    </p>
                    <h3 className="mt-1 font-serif text-2xl lg:text-3xl font-semibold text-slate-900 leading-tight">
                        Codice Civile e condominio
                    </h3>
                    <p className="mt-2 text-slate-600 leading-relaxed">
                        Il testo integrale degli articoli del Codice Civile e delle Disposizioni di attuazione in materia di condominio.
                    </p>
                </div>
                <span className="inline-flex items-center justify-center gap-2 rounded-full bg-teal-600 group-hover:bg-teal-700 text-white font-semibold min-h-12 px-6 py-2 w-full sm:w-auto shrink-0 transition-colors">
                    Consulta gli articoli
                    <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </span>
            </Link>
        </div>
    </section>
);
